export const setFirebaseToken = (firebaseToken) => {
  return {
    type: "SET_FIREBASE_TOKEN",
    payload: {
      firebaseToken,
    },
  };
};

export const setSelectedServiceRedux = (data) => {
  return {
    type: "SET_SELECTED_SERVICE",
    payload: {
      data,
    },
  };
};
